import { scenarioFlags } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    name: {
        // field
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    description: {
        // field
        label: "Описание",
        inputProps: { name: "description" },
        textarea: true,
    },
    externalData: {
        value: { propertyName: "" },
        config: {
            propertyName: {
                // field
                label: "PropertyName",
                inputProps: { name: "propertyName" },
            },
        },
    },
    startQuestionId: {
        // select
        label: "Начальный вопрос",
        inputProps: { name: "startQuestionId" },
        options: [],
    },
    intFlags: {
        // flags
        label: "scenarioFlagsEnum",
        inputProps: { name: "intFlags" },
        value: 0,
        flags: scenarioFlags,
    },
    id: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
